import { render, staticRenderFns } from "./diagramMsgCopy.vue?vue&type=template&id=f079f686&scoped=true"
import script from "./diagramMsgCopy.vue?vue&type=script&lang=js"
export * from "./diagramMsgCopy.vue?vue&type=script&lang=js"
import style0 from "./diagramMsgCopy.vue?vue&type=style&index=0&id=f079f686&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f079f686",
  null
  
)

export default component.exports